<template>
    <div class="sort-modal">
        <div class="sort-modal__title">Сортировать</div>

        <div class="sort-modal__form">
            <UIRadioGroup
                v-model="formSortOption"
                column-mobile
                class="sort-modal__options"
            >
                <UIRadio
                    v-for="option in options"
                    :id="option.label"
                    :value="option.value"
                    :label="option.label"
                />
            </UIRadioGroup>

            <UISimpleButton
                class="sort-modal__button"
                button-type="outlined"
                @clicked="onReset"
            >
                Сбросить
            </UISimpleButton>

            <UISimpleButton
                class="sort-modal__button"
                @clicked="onChange"
            >
                Применить
            </UISimpleButton>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { PropType, ref } from 'vue';

    import { SortOption } from '@/types/form.type.ts';

    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';
    import UIRadio from '@/components/ui/UIRadio/UIRadio.vue';
    import UIRadioGroup from '@/components/ui/UIRadioGroup/UIRadioGroup.vue';

    const { selectedOption } = defineProps({
        options: {
            type: Array as PropType<SortOption[]>,
            default: () => [],
        },
        selectedOption: {
            type: String,
        },
    });

    const emit = defineEmits<{
        (e: 'reset'): void,
        (e: 'change', newValue: string): void,
    }>();

    const formSortOption = ref<string | undefined>(selectedOption);

    function onReset(): void {
        emit('reset');
    }

    function onChange(): void {
        emit('change', formSortOption.value);
    }
</script>

<style scoped lang="scss">
    @use 'SortModal' as *;
</style>
